import { POLICY_STATUS_COLOR_MAP, POLICY_STATUS_TEXT } from '@constants';

import classes from './PolicyStatus.module.css';

// eslint-disable-next-line react/prop-types
export const PolicyStatus = ({ status, style = {} }) => {
  const color = POLICY_STATUS_COLOR_MAP[status];
  const text = POLICY_STATUS_TEXT[status];
  return (
    <div className={classes.status} style={{ background: color, ...style }}>
      <span className={classes.status_text}>{text}</span>
    </div>
  );
};
